// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".no-border[data-v-f3c97b02] {\n  border: none;\n}\n.column-min-width[data-v-f3c97b02] {\n  min-width: 8em;\n}", ""]);
// Exports
module.exports = exports;
